/*
When a user navigates to the sign-up page
Given the data is loaded
Then they will be presented with a form to fill out information about themselves or their company
When they select "Company"
Then they will be given a detailed form to request access for their organization to use Love Big
When they select "Individual"
Then they will be given a form to sign theirselves up as a user of the website.
Given the user has filled the form out with the minimum required information
When they click "Request Access"
Then they will be redirected to the home page and will be able to login with their new credentials
*/

//Packages
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import axios from "axios";
//Components
import CompanySignUpForm from "../../components/CompanySignUp";
import UserSignUpForm from "../../components/UserSignUp";
//Material UI Components
import {
  Grid,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Stack,
  Typography,
} from "@mui/material";
import { useSnackbar } from "notistack";

//API Route
import { Route } from "../../utils/config";
//Animation
import { motion } from "framer-motion";
//Assets
import stockImg from "../../assets/images/homeStock2.png";
import "./styles.css";
import { register } from "../../store/auth";

export default function Join() {
  const dispatch = useDispatch();
  const authData = useSelector((state) => state.auth);
  const { enqueueSnackbar } = useSnackbar();

  const [formType, setFormType] = useState("Organization");
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleSubmitCompany = (form) => {
    axios
      .post(`${Route}/Partners/RequestPartnership`, JSON.stringify(form), {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {})
      .catch((err) => {
        throw err;
      });
  };

  const handleSubmitUser = (form) => {
    dispatch(register(form));
  };

  useEffect(() => {
    if (authData.success) {
      enqueueSnackbar("Thank you for your interest! Your request is being processed. You will be notified when processing is complete.", { variant: "success" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authData]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <Grid
        container
        justifyContent={{ xs: "center", md: "space-between" }}
        mt={2}
        className="join-page"
      >
        <Grid item xs={10} sm={8} md={6}>
          <Grid container ml={{ md: 7 }}>
            <Stack>
              <Typography variant="h3" mb={6} mt={6} color="#052442">
                Join the Collective
              </Typography>
            </Stack>
            <Grid
              container
              item
              xs={12}
              justifyContent="flex-start"
              className="radios"
              pb={4}
              mb={4}
            >
              <FormControl component="fieldset">
                <Stack mb={4}>
                  <FormLabel component="legend" color="primary" mb={2}>
                    Are you an organization or an individual?
                  </FormLabel>
                </Stack>
                <RadioGroup
                  aria-label="roleSelect"
                  defaultValue="Organization"
                  onChange={(e) => setFormType(e.target.value)}
                  row
                >
                  <FormControlLabel
                    value="Organization"
                    control={<Radio />}
                    label="Organization"
                  />
                  <FormControlLabel
                    value="Individual"
                    control={<Radio />}
                    label="Individual"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item>
              {formType === "Organization" ? (
                <CompanySignUpForm
                  handleSubmit={handleSubmitCompany}
                ></CompanySignUpForm>
              ) : (
                <UserSignUpForm
                  handleSubmit={handleSubmitUser}
                ></UserSignUpForm>
              )}
            </Grid>
          </Grid>
        </Grid>

        {/* According to the design, there may be a second part to the company sign up form here, but 
        we have discussed that this portion of the form is not part of the MVP, and the client
        will likely want to add it later. */}

        <Grid item display={{ xs: "none", md: "block" }} md={5}>
          <img
            src={stockImg}
            className="stock-image"
            alt="Happy children smiling"
          ></img>
        </Grid>
      </Grid>
    </motion.div>
  );
}
